import { useLocalObservable } from "mobx-react";
import React, { createContext, ReactNode } from "react";
import { HistoryApi } from "../../api-client";
import { AuthContext } from "../Auth/auth.provider";
import useStore from "../../helpers/useStore";
import { createApiConfig } from "../../api/createApiConfig";
import HistoryStore from "./historyStore";
import { UserContext } from "../User/User.provider";

interface HistoryProviderProps {
  children: ReactNode;
}

export const HistoryContext = createContext<HistoryStore | null>(null);
HistoryContext.displayName = "HistoryContext";

export const HistoryProvider = ({ children }: HistoryProviderProps) => {
  const AuthenticationStore = useStore(AuthContext);
  const userStore = useStore(UserContext); // Use UserContext

  const apiClient = new HistoryApi(createApiConfig());

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const store = useLocalObservable(() => new HistoryStore(apiClient, userStore, AuthenticationStore));

  store.apiClient = apiClient;
  // store.getCancelledAppointments().then((res) => { console.log("CancelledAppointmentsdfsf:"); });

  return <HistoryContext.Provider value={store}>{children}</HistoryContext.Provider>;
};
